import { render, staticRenderFns } from "./LmMenuCreatorNewOrEdit.vue?vue&type=template&id=06562ff0&"
import script from "./LmMenuCreatorNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./LmMenuCreatorNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./LmMenuCreatorNewOrEdit.vue?vue&type=style&index=0&id=06562ff0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports